/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 723bf495da6681ff45c907be0c5a248b */

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type HomeScreenQueryVariables = {
    highlightedGuildSlug: string;
};
export type HomeScreenQueryResponse = {
    readonly viewer: {
        readonly id: string;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"UnauthenticatedHomeScreen_query">;
};
export type HomeScreenQuery = {
    readonly response: HomeScreenQueryResponse;
    readonly variables: HomeScreenQueryVariables;
};



/*
query HomeScreenQuery(
  $highlightedGuildSlug: String!
) {
  viewer {
    id
  }
  ...UnauthenticatedHomeScreen_query
}

fragment EventAttendButtonHybridAttend_event on Event {
  rowId
  prettyUrl
  hasVenue
  hasExternalUrl
  myAttendance {
    status
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventAttendButtonNew_event on Event {
  rowId
  prettyUrl
  endAt
  hasExternalUrl
  hasVenue
  myAttendance {
    status
    userId
    id
  }
  owner {
    __typename
    ... on Guild {
      slugId
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  ...EventAttendButtonSingleAttend_event
  ...EventAttendButtonHybridAttend_event
}

fragment EventAttendButtonNew_query on Query {
  viewer {
    id
  }
}

fragment EventAttendButtonSingleAttend_event on Event {
  rowId
  prettyUrl
  hasVenue
  hasExternalUrl
  myAttendance {
    status
    id
  }
  owner {
    __typename
    ... on Guild {
      myMembership {
        membershipLevel
        id
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventAttendeesOverlap_eventAttendees on EventAttendeesConnection {
  edges {
    node {
      user {
        firstName
        lastName
        ...UserPrimaryPhotoNew_user
        id
      }
      id
    }
    cursor
  }
}

fragment EventItemEventCardPhoto_event on Event {
  prettyUrl
  visibility
  coverPhoto {
    rowId
    contentType
    id
  }
}

fragment EventItemNew_event on Event {
  name
  startAt
  prettyUrl
  hasExternalUrl
  hasVenue
  visibility
  coverPhoto {
    rowId
    id
  }
  eventOwner: owner {
    __typename
    ... on Guild {
      name
      slugId
      primaryPhoto {
        rowId
        id
      }
      ...GuildPrimaryPhotoNew_guild
    }
    ... on User {
      firstName
      lastName
      slugId
      ...UserPrimaryPhotoNew_user
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  attendeesByRelevance: eventAttendeesByRelevance(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL, WAITING_IN_PERSON]}}, first: 8) {
    totalCount
    ...EventAttendeesOverlap_eventAttendees
  }
  attendingCount: eventAttendees(filter: {status: {in: [ATTENDING_IN_PERSON, ATTENDING_VIRTUAL]}}) {
    totalCount
  }
  waitingCount: eventAttendees(condition: {status: WAITING_IN_PERSON}) {
    totalCount
  }
  ...EventAttendButtonNew_event
  ...EventItemEventCardPhoto_event
  ...EventItemPresentations_event
}

fragment EventItemNew_query on Query {
  ...EventAttendButtonNew_query
}

fragment EventItemPresentations_event on Event {
  eventItemPresentations: presentations(orderBy: [CREATED_AT_ASC, ID_ASC]) {
    edges {
      node {
        title
        rowId
        presenterFirstName
        presenterLastName
        presenter {
          firstName
          lastName
          ...UserPrimaryPhotoNew_user
          id
        }
        id
      }
      cursor
    }
  }
}

fragment GraphQLImage_image on Image {
  url
}

fragment GuildCard_guild on Guild {
  slugId
  rowId
  name
  description
  type
  myMembership {
    membershipLevel
    id
  }
  ...GuildMembershipStatus_guild
  ...GuildJoinConfirmationContent_guild
  ...GuildPrimaryPhoto_guild
  primaryPhoto {
    id
  }
  backgroundPhoto {
    ...GraphQLImage_image
    id
  }
}

fragment GuildJoinConfirmationContent_guild on Guild {
  name
  rowId
  slugId
}

fragment GuildMembershipStatus_guild on Guild {
  myMembership {
    membershipLevel
    id
  }
  networkMembers {
    totalCount
  }
}

fragment GuildPrimaryPhotoNew_guild on Guild {
  name
  rowId
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment GuildPrimaryPhoto_guild on Guild {
  type
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}

fragment HomeScreenPresentationsCard_query on Query {
  presentationsCard: presentations(first: 12, orderBy: [CREATED_AT_DESC, ID_ASC]) {
    edges {
      node {
        prettyUrl
        presenter {
          id
        }
        id
      }
      cursor
    }
  }
}

fragment PresentationItem_presentation on Presentation {
  rowId
  description
  title
  presenterFirstName
  presenterLastName
  prettyUrl
  presenter {
    slugId
    firstName
    lastName
    ...UserPrimaryPhoto_user
    id
  }
}

fragment UnauthenticatedHomeScreen_query on Query {
  ...HomeScreenPresentationsCard_query
  ...EventItemNew_query
  nodeBySlugId(id: $highlightedGuildSlug) {
    __typename
    ... on Guild {
      ...GuildCard_guild
      upcomingEvents: eventsByTimeSelection(first: 1, timeSelection: UPCOMING, orderBy: [START_AT_ASC, ID_ASC]) {
        edges {
          node {
            ...EventItemNew_event
            id
          }
        }
      }
      pastEvents: eventsByTimeSelection(first: 1, timeSelection: PAST, orderBy: [START_AT_DESC, ID_ASC]) {
        edges {
          node {
            ...EventItemNew_event
            id
          }
        }
      }
      upcomingPresentations: presentationsByEventTimeSelection(first: 1, orderBy: [CREATED_AT_ASC, ID_ASC], timeSelection: UPCOMING) {
        edges {
          node {
            ...PresentationItem_presentation
            id
          }
        }
      }
      pastPresentations: presentationsByEventTimeSelection(first: 1, orderBy: [CREATED_AT_DESC, ID_ASC], timeSelection: OTHER) {
        edges {
          node {
            ...PresentationItem_presentation
            id
          }
        }
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  rankedGuilds(first: 5, guildType: GUILD) {
    edges {
      node {
        name
        slugId
        type
        ...GuildPrimaryPhoto_guild
        ...GuildCard_guild
        id
      }
      cursor
    }
  }
}

fragment UserDefaultPhoto_user on User {
  rowId
  emailMd5
}

fragment UserPrimaryPhotoNew_user on User {
  firstName
  lastName
  rowId
  emailMd5
  primaryPhoto {
    rowId
    contentType
    id
  }
}

fragment UserPrimaryPhoto_user on User {
  ...UserDefaultPhoto_user
  primaryPhoto {
    ...GraphQLImage_image
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "highlightedGuildSlug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_DESC",
    "ID_ASC"
  ]
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "GuildMembership",
  "kind": "LinkedField",
  "name": "myMembership",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipLevel",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "UsersConnection",
  "kind": "LinkedField",
  "name": "networkMembers",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v1/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "backgroundPhoto",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v20 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v21 = {
  "kind": "Literal",
  "name": "timeSelection",
  "value": "UPCOMING"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v23 = [
  (v9/*: any*/),
  (v1/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v22/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v2/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v29 = [
  (v24/*: any*/),
  (v25/*: any*/),
  (v9/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v1/*: any*/)
],
v30 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": [
    "CREATED_AT_ASC",
    "ID_ASC"
  ]
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterFirstName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presenterLastName",
  "storageKey": null
},
v34 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EventsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startAt",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExternalUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasVenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "coverPhoto",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          },
          {
            "alias": "eventOwner",
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v10/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "primaryPhoto",
                    "plural": false,
                    "selections": (v23/*: any*/),
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "type": "Guild",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/)
                ],
                "type": "User",
                "abstractKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "attendeesByRelevance",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "status": {
                    "in": [
                      "ATTENDING_IN_PERSON",
                      "ATTENDING_VIRTUAL",
                      "WAITING_IN_PERSON"
                    ]
                  }
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 8
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendeesByRelevance",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventAttendeesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendee",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v29/*: any*/),
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\"]}},first:8)"
          },
          {
            "alias": "attendingCount",
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "status": {
                    "in": [
                      "ATTENDING_IN_PERSON",
                      "ATTENDING_VIRTUAL"
                    ]
                  }
                }
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
          },
          {
            "alias": "waitingCount",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "status": "WAITING_IN_PERSON"
                }
              }
            ],
            "concreteType": "EventAttendeesConnection",
            "kind": "LinkedField",
            "name": "eventAttendees",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": "eventAttendees(condition:{\"status\":\"WAITING_IN_PERSON\"})"
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventAttendee",
            "kind": "LinkedField",
            "name": "myAttendance",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v8/*: any*/),
                  (v13/*: any*/)
                ],
                "type": "Guild",
                "abstractKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "eventItemPresentations",
            "args": [
              (v30/*: any*/)
            ],
            "concreteType": "PresentationsConnection",
            "kind": "LinkedField",
            "name": "presentations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PresentationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Presentation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      (v9/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "presenter",
                        "plural": false,
                        "selections": (v29/*: any*/),
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v35 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PresentationsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Presentation",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v11/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "presenter",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v9/*: any*/),
              (v26/*: any*/),
              (v18/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeScreenQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UnauthenticatedHomeScreen_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeScreenQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": "presentationsCard",
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 12
          },
          (v4/*: any*/)
        ],
        "concreteType": "PresentationsConnection",
        "kind": "LinkedField",
        "name": "presentations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PresentationsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Presentation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "presenter",
                    "plural": false,
                    "selections": (v2/*: any*/),
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "presentations(first:12,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"])"
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "highlightedGuildSlug"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              {
                "alias": "upcomingEvents",
                "args": [
                  (v20/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "START_AT_ASC",
                      "ID_ASC"
                    ]
                  },
                  (v21/*: any*/)
                ],
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_ASC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "pastEvents",
                "args": [
                  (v20/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      "START_AT_DESC",
                      "ID_ASC"
                    ]
                  },
                  {
                    "kind": "Literal",
                    "name": "timeSelection",
                    "value": "PAST"
                  }
                ],
                "concreteType": "EventsConnection",
                "kind": "LinkedField",
                "name": "eventsByTimeSelection",
                "plural": false,
                "selections": (v34/*: any*/),
                "storageKey": "eventsByTimeSelection(first:1,orderBy:[\"START_AT_DESC\",\"ID_ASC\"],timeSelection:\"PAST\")"
              },
              {
                "alias": "upcomingPresentations",
                "args": [
                  (v20/*: any*/),
                  (v30/*: any*/),
                  (v21/*: any*/)
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentationsByEventTimeSelection",
                "plural": false,
                "selections": (v35/*: any*/),
                "storageKey": "presentationsByEventTimeSelection(first:1,orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
              },
              {
                "alias": "pastPresentations",
                "args": [
                  (v20/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "timeSelection",
                    "value": "OTHER"
                  }
                ],
                "concreteType": "PresentationsConnection",
                "kind": "LinkedField",
                "name": "presentationsByEventTimeSelection",
                "plural": false,
                "selections": (v35/*: any*/),
                "storageKey": "presentationsByEventTimeSelection(first:1,orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"],timeSelection:\"OTHER\")"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          },
          (v28/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 5
          },
          {
            "kind": "Literal",
            "name": "guildType",
            "value": "GUILD"
          }
        ],
        "concreteType": "GuildsConnection",
        "kind": "LinkedField",
        "name": "rankedGuilds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GuildsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Guild",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v8/*: any*/),
                  (v12/*: any*/),
                  (v18/*: any*/),
                  (v9/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/),
                  (v19/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "rankedGuilds(first:5,guildType:\"GUILD\")"
      }
    ]
  },
  "params": {
    "id": "ad88971e1f759291d597ef483c27eb14d08147f67cfbb8f0357f4adb4b907df2",
    "metadata": {},
    "name": "HomeScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
(node as any).hash = '30ef68fcc2d82c70c06a1a0ff0587ff9';
export default node;
